import Icon from "@ant-design/icons";

export const UserReassign = (props: any) => {
  const userReAssignIcon = () => (
    <svg
      width="32"
      height="32"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.532 17.9815V19.5552C15.0608 19.3887 14.5538 19.2981 14.0256 19.2981C11.5297 19.2981 9.50641 21.3214 9.50641 23.8173H8C8 20.4894 10.6978 17.7916 14.0256 17.7916C14.5458 17.7916 15.0506 17.8576 15.532 17.9815ZM14.0256 17.0384C11.5288 17.0384 9.50641 15.0161 9.50641 12.5192C9.50641 10.0224 11.5288 8 14.0256 8C16.5225 8 18.5448 10.0224 18.5448 12.5192C18.5448 15.0161 16.5225 17.0384 14.0256 17.0384ZM14.0256 15.532C15.6902 15.532 17.0384 14.1838 17.0384 12.5192C17.0384 10.8546 15.6902 9.50641 14.0256 9.50641C12.361 9.50641 11.0128 10.8546 11.0128 12.5192C11.0128 14.1838 12.361 15.532 14.0256 15.532ZM19.6132 20.0513H22.314V21.5577H19.6132L20.9904 22.9348L19.9252 24L16.7296 20.8045L19.9252 17.6089L20.9904 18.6741L19.6132 20.0513Z"
        fill="#333333"
      />
    </svg>
  );
  return <Icon component={userReAssignIcon} {...props} />;
};
